const GUEST_KEY = 'nn_theory_completed_lessons_guest';
const SUBLESSON_GUEST_KEY = 'nn_theory_sublesson_progress_guest';

function storageKey(userId: string | null): string {
  return userId ? `nn_theory_completed_lessons_${userId}` : GUEST_KEY;
}

function sublessonStorageKey(userId: string | null): string {
  return userId ? `nn_theory_sublesson_progress_${userId}` : SUBLESSON_GUEST_KEY;
}

export function readCompletedLessons(userId: string | null): Set<number> {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return new Set();

    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();

    return new Set(
      parsed.filter((id): id is number => typeof id === 'number' && Number.isFinite(id))
    );
  } catch {
    return new Set();
  }
}

export function markLessonCompleted(userId: string | null, lessonId: number): void {
  const completed = readCompletedLessons(userId);
  completed.add(lessonId);

  try {
    localStorage.setItem(storageKey(userId), JSON.stringify([...completed]));
  } catch {
    // ignore
  }
}

export function readSublessonProgress(userId: string | null): Map<number, number> {
  try {
    const raw = localStorage.getItem(sublessonStorageKey(userId));
    if (!raw) return new Map();

    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return new Map();

    const progress = new Map<number, number>();
    for (const [key, value] of Object.entries(parsed)) {
      const lessonId = Number(key);
      if (!Number.isFinite(lessonId) || typeof value !== 'number' || !Number.isFinite(value)) {
        continue;
      }
      progress.set(lessonId, value);
    }

    return progress;
  } catch {
    return new Map();
  }
}

export function markSublessonReached(
  userId: string | null,
  lessonId: number,
  sublessonIndex: number
): void {
  if (sublessonIndex < 0) return;

  const progress = readSublessonProgress(userId);
  const current = progress.get(lessonId) ?? -1;
  if (sublessonIndex <= current) return;

  progress.set(lessonId, sublessonIndex);

  try {
    const payload: Record<string, number> = {};
    for (const [id, index] of progress) {
      payload[String(id)] = index;
    }
    localStorage.setItem(sublessonStorageKey(userId), JSON.stringify(payload));
  } catch {
    // ignore
  }
}
